<table class="result-table">
  <tbody>
    <tr *ngFor="let item of attributes">
      <td>{{item.label}}</td>
      <td>{{item.value}}</td>
      <td>
        <button mat-icon-button [color]="tags.length ? 'accent' : ''" (click)="filter(item.tag)" *ngIf="item.tag">
          <mat-icon *ngIf="tags.includes(item.tag)" i18n-title title="Filter">check_box</mat-icon>
          <mat-icon *ngIf="!tags.includes(item.tag)" i18n-title title="Filter">check_box_outline_blank</mat-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
